<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->

<template>
  <el-container class="layout" v-clickoutside="visible=false" @click="hidePanel">
    <el-main>
      <div class="layout-header">
        <div class="header-title h60 ml10 pointer">
          <div class="icon spacing pointer select_main_tone mr10">
            <el-icon :size="30" v-if="kaiGuan" @click="kaiGuanClick(false)">
              <Close />
            </el-icon>
            <i class="bi bi-list" style="font-size: 2.2em; line-height: 20px" v-else @click="kaiGuanClick(true)"></i>
          </div>
          <!-- 左侧导航栏开关按钮 -->
          <div class="logo spacing mr10" @click="logoClick()">
            <img :src="url + xtxxInfo.tb" style="width: 30px; height: 30px">
          </div>
          <div class="title spacing" @click="logoClick()">{{xtxxInfo.xmmc}}</div>
        </div>
        <!-- 图标按钮组 -->
        <div class="header-but-group h60 mr10">
          <div class="ri-qi mr10">
            {{  riQi }} {{ xingQi }}
          </div>
          <div class="tian-qi">
            <ul>
              <!-- province 北京 -->
              <!-- <li class="sheng">{{ tianQi.province}}</li> -->

              <!-- <li class="shi">{{ tianQi.reporttime
}}</li> -->
              <!-- reporttime 2023-07-27 09:33:46 -->
              <li class="shi">{{ tianQi.city}}</li>
              <!-- city：北京城区 -->
              <!-- <li class="qu-xian">{{xingQi }}</li> -->
            </ul>
            <ul>

              <li class="tian-qi-xian-xiang">{{ tianQi.text }}</li>
              <!-- humidity：湿度 -->
              <!-- <li class="tian-qi-xian-xiang">湿度:{{ tianQi.humidity }}</li> -->
              <!-- temperature：29 -->
              <li class="wen-du">{{ tianQi.temperature }}℃</li>
              <!-- 多云 -->
              <li class="wen-du">{{ tianQi.weather }}</li>
              <li></li>
            </ul>
          </div>
          <!-- 消息 -->
          <i v-if="wdxx === 0" class="bi bi-bell spacing pointer" style="font-size: 20px" @click="openYiDu=true"></i>
          <el-badge v-else :value="wdxx" :max="99" class="spacing pointer" @click="openYiDu=true">
            <i class="bi bi-bell" style="font-size: 20px"></i>
          </el-badge>
          <el-dropdown class="spacing pointer">
            <span class="el-dropdown-link">
              <i class="bi bi-person-circle mr5" style="font-size: 16px"></i>
              <span>{{ userInfo.xm }}</span>
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>个人中心</el-dropdown-item>
                <el-dropdown-item @click="openXgmc=true">修改密码</el-dropdown-item>
                <el-dropdown-item @click="signOut">退出</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      <div class="zi-kuang-jia">
        <!-- 左侧菜单 -->
        <div class="menu" v-show="kaiGuan">
          <el-menu :default-openeds="defaultOpeneds" :default-active="currentMenuId" unique-opened class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="menuSelect">
            <div v-for="(item, index) in menuList" :key="item.id">
              <el-sub-menu v-if="item.children" :index="index+''" @click="abbc(item)">
                <template #title>
                  <div class="default_main_tone">
                    <span>{{ item.cdmc }}</span>
                  </div>
                </template>
                <el-menu-item class="default_auxiliary_tone" v-for="child in item.children" :key="child.id" :index="child.id+''" @click="subMenuSelect(child)">
                  {{ child.cdmc }}
                </el-menu-item>
              </el-sub-menu>
              <el-menu-item v-else :index="index+''" @click="subMenuSelect(item)">
                <span>{{ item.cdmc }}</span>
              </el-menu-item>
            </div>
          </el-menu>
          <!-- 版本号 -->
          <div class="ban-ben-hao">{{ xtxxInfo.dqbbh }}</div>
        </div>
        <!-- 左侧菜单开关 -->
        <div class="kaiGuan" :style="kaiGuan ? 'left: 220px;' : 'left: 0;'">
          <el-icon class="kaiGuanBut pointer" v-if="kaiGuan" @click="kaiGuanClick(false)">
            <ArrowLeft />
          </el-icon>
          <el-icon class="kaiGuanBut pointer" v-else @click="kaiGuanClick(true)">
            <ArrowRight />
          </el-icon>
        </div>
        <!-- 内容区域 -->
        <div class="content" :style="kaiGuan ? 'width: calc(100% - 220px);margin-left: 220px;' : 'width: 100%; margin-left: 0;'">
          <!-- 标签删除后跳转到首页 -->
          <el-tabs v-if="currentMenuId !== '1'" type="border-card" v-model="currentMenuId" closable @tab-remove="menuleTabRemove" @tab-change="menuleTabChange">
            <!-- <el-tab-pane label="首页" name="1"></el-tab-pane> -->
            <el-tab-pane v-for="(item, index) in menu" :key="index" :name="item.id">
              <template #label>
                <div @contextmenu.prevent.native="openMenu($event, item, index)">{{ item.cdmc }}</div>
              </template>
            </el-tab-pane>
          </el-tabs>
          <!-- <div> -->
          <ul id="myPanel" v-if="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
            <li><el-button link @click="menuleTabRemove(dqcd.id)">关闭</el-button></li>
            <li><el-button link @click="removeTab(dqcd.id, 'zuoce')" :disabled="dqcdind === 0">关闭左侧标签页</el-button></li>
            <li><el-button link @click="removeTab(dqcd.id, 'youce')" :disabled="menu.length === dqcdind + 1">关闭右侧标签页</el-button></li>
            <li><el-button link @click="removeTab(dqcd.id, 'qita')" :disabled="menu.length === 1">关闭其他标签页</el-button></li>
            <li><el-button link @click="removeTab(dqcd.id, 'quanbu')" :disabled="menu.length === 1">关闭全部标签页</el-button></li>
          </ul>
          <!-- </div> -->
          <div class="tab_nei_rong" :style="currentMenuId !== '1'?'height: calc(100vh - 100px);':'height: calc(100vh - 61px);'">
            <router-view v-slot="{ Component }" :key="dateKey">
              <keep-alive v-if="$route.meta.keepAlive">
                <component :is="Component"></component>
              </keep-alive>
              <component v-if="!$route.meta.keepAlive" :is="Component" />
            </router-view>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
  <xiugaimima v-if="openXgmc" v-model:openXgmc="openXgmc" />
  <tzgglist v-if="openYiDu" v-model:openYiDu="openYiDu" @ReturnData="weiDuXiaoXi" />
</template>
<script setup>
import { ref, watch, defineProps } from 'vue'
import { useRouter } from 'vue-router'
import { actionPost, actionGet } from '@/api/common.js'
import { backToLogin } from '@/utils/login.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import { youJianCaiDanGuanBiGiaoQian, getDate, getWeeks } from '@/utils/index'
import axios from 'axios'
import xiugaimima from '@/views/login/xiugaimima'
import tzgglist from '@/components/home/tongzhigonggao/list'

const router = useRouter()
const openXgmc = ref(false)
const openYiDu = ref(false)

const currentMenuId = ref('1') // 内部标签id
const menu = ref([]) // 内部标签列表
const menuList = ref() // 菜单列表
const defaultOpeneds = ref([0])

// 点击菜单刷新
const dateKey = ref(new Date()) // 菜单key
const menuSelect = () => {
  dateKey.value = new Date()
}

// 获取系统信息
const url = ref(process.env.VUE_APP_BASE_API)
const xtxxInfo = ref({}) // 系统信息
const initXiTongXinXi = () => {
  actionPost({ url: '/api/v2/sys/xitongxinxi/list', data: {} }).then((res) => {
    if (res.code === 200) {
      xtxxInfo.value = res.data[0]
      // 修改网站title
      document.title = xtxxInfo.value.xmmc
      // 修改网站ico图标
      const favicon = document.querySelector('link[rel="icon"]')
      favicon.href = url.value + xtxxInfo.value.tb
    } else {
      warningPrompt(res.message)
    }
  })
}
initXiTongXinXi()
const kaiGuan = ref(false) // 子菜单开关
const kaiGuanClick = (val) => {
  kaiGuan.value = val
}
// 点击logo返回首页
const logoClick = () => {
  kaiGuan.value = false
  currentMenuId.value = '1'
  sessionStorage.setItem('menuId', '1')
  router.push({ path: '/', query: { t: Date.now() } })
}

// 获取天气
const riQi = ref(getDate('YYYY', 'MM', 'DD')) // 日期
const xingQi = ref(getWeeks()) // 星期
// const tianQi = ref({ location: {}, now: {} }) // 天气
const tianQi = ref({}) // 天气
const initTianQi = async () => {
  actionPost({
    url: '/api/v2/bangong/tongzhigonggaojieshouren/tianqi',
    data: {}
  }).then((res) => {
    if (res.code === 200) {
      // res.data = JSON.parse(res.message)
      tianQi.value = res.data
      // console.log(res.data)
    } else {
      warningPrompt(res.message)
    }
  })
}
initTianQi()

const userInfo = ref({})
const initUserInfo = async () => {
  actionPost({ url: '/api/v2/account/getCurrentUserJzg', data: {} }).then(
    (res) => {
      const info = {
        id: res.data.id,
        xm: res.data.xm,
        zw: res.data.zygwzwmc,
        zp: res.data.zp
      }
      userInfo.value = info
      sessionStorage.setItem('userInfo', JSON.stringify(info))
    }
  )
}
initUserInfo()
const timer = ref(null)
// 消息
const lunXun = () => {
  timer.value = window.setInterval(() => {
    setTimeout(function () {
      weiDuXiaoXi()
    }, 600)
  }, 60000)
}
lunXun()
const wdxx = ref() // 未读信息
const weiDuXiaoXi = async () => {
  actionPost({
    url: '/api/v2/bangong/tongzhigonggaojieshouren/weidu',
    data: {}
  }).then((res) => {
    if (res.code === 200) {
      wdxx.value = res.data
    } else {
      warningPrompt(res.message)
      clearInterval(null)
    }
  })
}
weiDuXiaoXi()
// 退出登录
const signOut = async () => {
  actionPost({ url: '/api/v2/account/logout', data: {} }).then((res) => {
    if (res.code === 200) {
      sessionStorage.clear()
      clearInterval(null)
      backToLogin()
    }
  })
}

// 初始化菜单
const initMenuList = () => {
  const o = {
    url: '/api/v2/sys/menu/denglurentree',
    data: {}
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      menuList.value = res.data
      defaultOpeneds.value = JSON.parse(
        sessionStorage.getItem('defaultOpeneds')
      ) || [0]
    } else {
      warningPrompt(res.message)
    }
  })
}
initMenuList()
// 展开菜单
const handleOpen = (key, keyPath) => {
  defaultOpeneds.value[0] = key
  sessionStorage.setItem('defaultOpeneds', JSON.stringify(defaultOpeneds.value))
}
// 关闭菜单
const handleClose = (key, keyPath) => {
  defaultOpeneds.value = []
  sessionStorage.setItem('defaultOpeneds', JSON.stringify(defaultOpeneds.value))
}
const initTabsList = () => {
  currentMenuId.value = sessionStorage.getItem('menuId') || '1'
  menu.value = JSON.parse(sessionStorage.getItem('SET_MENU_LIST')) || []
}
initTabsList()
const abbc = (item) => {
  // console.log(item)
}
// 点击子菜单
const subMenuSelect = (item) => {
  const list = JSON.parse(sessionStorage.getItem('SET_MENU_LIST')) || []
  if (JSON.stringify(list).indexOf(JSON.stringify(item)) === -1) {
    list.push(item)
    sessionStorage.setItem('SET_MENU_LIST', JSON.stringify(list))
    initTabsList()
  }
  sessionStorage.setItem('menuId', item.id)
  currentMenuId.value = item.id
  menuleTabChange(item.id)
}
// 点击标签
const menuleTabChange = (val) => {
  sessionStorage.setItem('menuId', val)
  currentMenuId.value = val
  if (val === '1') {
    router.push({ path: '/', query: { t: Date.now() } })
  }
  if (menu.value && val !== '1') {
    menu.value.forEach((element) => {
      if (element.id === val) {
        router.push({ path: element.cdlj, query: { t: Date.now() } })
      }
    })
  }
}
// 右键菜单 开始
const visible = ref(false)
const dqcd = ref({})
const dqcdind = ref()
const top = ref()
const left = ref()
const openMenu = (e, item, index) => {
  dqcd.value = item
  dqcdind.value = index
  const x = e.pageX // 这个应该是相对于整个浏览器页面的x坐标，左上角为坐标原点（0,0）
  const y = e.pageY // 这个应该是相对于整个浏览器页面的y坐标，左上角为坐标原点（0,0）
  top.value = y
  left.value = x
  visible.value = true // 显示菜单
}
// 删除标签
const menuleTabRemove = (val) => {
  visible.value = false // 关闭菜单
  let dqInd = null
  menu.value.forEach((element, index) => {
    if (element.id === val) {
      dqInd = index

      menu.value.splice(index, 1)
      sessionStorage.setItem('SET_MENU_LIST', JSON.stringify(menu.value))
    }
  })
  if (menu.value.length === 0) {
    logoClick()
  } else {
    if (currentMenuId.value === val) {
      if (dqInd === 0) {
        currentMenuId.value = menu.value[dqInd].id
      } else {
        currentMenuId.value = menu.value[dqInd - 1].id
      }
    }
  }
}
// 右键菜单关闭标签 [id]右键点击ID [currentId]当前选中ID [idType]当前选中ID [type]右键菜单类型 [listType]标签类型 [list]列表
const removeTab = (id, type) => {
  visible.value = false // 关闭菜单
  youJianCaiDanGuanBiGiaoQian(
    id,
    currentMenuId.value,
    'menuId',
    type,
    'SET_MENU_LIST',
    menu.value,
    function () {
      initTabsList()
    }
  )
}
// 点击区域外关闭右键菜单
const hidePanel = (event) => {
  const sp = document.getElementById('myPanel')

  if (sp) {
    if (!sp.contains(event.target)) {
      // 这句是说如果我们点击到了id为myPanel以外的区域
      visible.value = false // 关闭菜单
    }
  }
}
// 右键菜单 结束
// window.onresize = () => {
//   return (() => {
//     const screenWidth = document.body.clientWidth
//     const width = document.querySelector('.el-dialog').clientWidth
//     if (screenWidth < width) {
//       document.getElementsByClassName('el-dialog')[0].style.width = '95%'
//     }
//     const screenHeight = document.body.clientHeight
//     const height = document.querySelector('.el-dialog').clientHeight
//     if (screenHeight < height) {
//       document.getElementsByClassName('el-dialog')[0].style.height = '95%'
//     }
//   })()
// }
</script>

<style lang="less" scoped>
.layout-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tian-qi {
  display: flex;
  ul {
    display: flex;
    li {
      margin-right: 5px;
    }
  }
}
.layout {
  width: 100vw;
  height: 100vh;
  .el-main {
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
    .el-row {
      width: 100vw;
      height: 60px;
      display: flex;
      justify-content: flex-start;
    }
  }
  // 头部-左侧
  .header-title {
    display: flex;
    align-items: center;

    .title {
      font-weight: bold;
      font-size: 24px;
    }

    .logo {
      width: 30px;
      height: 30px;
    }

    .icon {
      width: 30px;
      height: 30px;
      color: var(--main_tone1);
    }
  }

  // 内容区域标签页
  .zi-kuang-jia {
    height: calc(100% - 60px);
    .kaiGuan {
      position: absolute;
      top: 100px;
      bottom: 40px;
      z-index: 9;
      display: flex;
      align-items: center;
      .kaiGuanBut {
        height: 40px;
        width: 19px;
        border: 1px solid var(--frame_tone);
        background-color: #fff;
      }
    }
    .el-card + .el-card {
      margin-top: 10px;
    }
    .el-tabs__item.is-active {
      color: #06bac0;
    }
    .title {
      font-size: 20px;
      font-weight: bold;
    }

    // 内嵌导航
    .menu {
      width: 220px;
      height: calc(100% - 60px);
      background-color: #fff;
      position: fixed;
      .el-menu {
        overflow: auto;
        height: calc(100% - 40px);
        // height: var(--kuang-jia-height);
        :deep(.el-sub-menu__title:hover) {
          color: var(--select_main_tone);
          .default_main_tone {
            color: var(--select_main_tone) !important;
          }
        }
      }
      .ban-ben-hao {
        height: 40px;
        width: 100%;
        text-align: center;
        line-height: 40px;
        position: absolute;
        bottom: 0;
      }
    }

    // 框架
    .content {
      height: var(--kuang-jia-height);
      float: left;
      min-height: 100%;
      -webkit-transition: margin-left 0.28s;
      transition: margin-left 0.28s;
      position: relative;
      border: 1px solid var(--el-border-color);

      :deep(.el-tabs__header) {
        display: block;
      }
      // :deep(.el-tabs__item:nth-child(1)) {
      //   .el-icon {
      //     display: none;
      //   }
      // }
      :deep(.el-tabs--border-card) {
        border: 0px;
      }
      :deep(.el-tabs__nav-scroll) {
        border-bottom: 0px;
      }
      // 标签
      .el-tabs {
        :deep(.el-tabs__content) {
          display: none;
        }
      }
      // 标签页内容区域
      .tab_nei_rong {
        overflow: auto;
        padding-top: 20px;
        background-color: #fff;
      }
    }
    .subMenu :deep(.el-sub-menu__icon-arrow) {
      display: none;
    }
    .default_main_tone,
    .el-menu-item {
      font-size: 16px;
    }
  }

  /* 头部-图标按钮组 */
  .header-but-group {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 60px;
    // 考勤
    .kao-qin {
      display: flex;
      .iconfont {
        height: 30px;
        width: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid;
        border-radius: 30%;
        margin-right: 10px;
        color: #fff;
      }
      .iconfont:nth-child(1) {
        border-color: #e6a23c;
        background-color: #e6a23c;
      }
      .iconfont:nth-child(2) {
        border-color: #67c23a;
        background-color: #67c23a;
      }
      .iconfont:nth-child(3) {
        border-color: #909399;
        background-color: #909399;
      }
    }

    // 图标组
    .spacing + .spacing {
      margin-left: 20px;
    }

    // 菜单框
    :deep(.el-cascader) {
      max-width: 184px;
      margin-left: 10px;
    }

    // 标记
    .el-badge {
      height: 32px;

      :deep(.el-badge__content.is-fixed) {
        top: 4px;
        transform: translateY(-60%) translateX(90%);
      }
    }

    // 个人中心下拉框
    .el-dropdown-link {
      display: flex;
      align-items: center;
    }
    .el-dropdown-link:focus-visible {
      outline: -webkit-focus-ring-color auto 0px;
    }
  }
}
.el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}
// 右键菜单
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: fixed; //关键样式设置固定定位
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
  text-align: center;
}
.contextmenu li:hover {
  background: #eee;
}
</style>
